
import {
    EXPERT_BIO_COLLABS_RESPONSE,
    EXPERT_BIO_COLLABS_FAILURE,
    CLEAR_EXPERT_BIO_RESULTS
 } from '../../actions/types';
 
 const initialState = {
    isFetching: true,
    collabs: [],
    error: false
 };


const setFailure = (state, action) => {
    return {
        ...state,
        isFetching: false,
        error: true,
        collabs: []
    }
}

const setResults = (state, action) => {
    
    let collabs = action.payload.collabs || [];

    return {
        ...state,
        isFetching: false,
        error: false,
        collabs
    }
    
}
 
 export default (state = initialState, action) => {
     switch (action.type) {
        case EXPERT_BIO_COLLABS_RESPONSE:
             return setResults(state,action);
             break;
         
        case EXPERT_BIO_COLLABS_FAILURE:
             return setFailure(state,action);
             break;
        
        case CLEAR_EXPERT_BIO_RESULTS:
             return initialState;
             break;

        default:
             return state;
             break;
     }
 }